export default __webpack_public_path__ + "locales/ro/PeopleTranslations.json?hash=5bbd995ece2293a7f26c2b227b8854dd";